import { createSelector } from 'reselect';
import { STATE_NAME } from './constants';

export const getStateSlice = state => state.get(STATE_NAME);

export const getUtensilsMap = state => getStateSlice(state).get('utensils');
export const getMarketUtensils = state =>
  getStateSlice(state).get('marketUtensils');

export const getUtensils = createSelector(
  getUtensilsMap,
  utensilsMap => utensilsMap.toList().sortBy(utensil => utensil.get('name'))
);

// export const getMarketUtensils = createSelector(
//   getMarketUtensilsMap,
//   utensilsMap => utensilsMap.toList().sortBy(utensil => utensil.get('name'))
// );

export const getUtensilById = id =>
  createSelector(
    getUtensilsMap,
    utensilsMap => utensilsMap.get(id)
  );

export const getIsFetching = state => getStateSlice(state).get('isFetching');
export const getFetching = state =>
  getStateSlice(state).get('isFetchingUtensils');

export const getFetchError = state => getStateSlice(state).get('fetchError');

export const getIsAllFetched = state =>
  getStateSlice(state).get('isAllFetched');
